module.exports = __webpack_public_path__ + "static/media/infrastructure.766f30c1.jpg";